/*
example

<div class="js-expander">
   <span class="js-expander-toggle" role="button" aria-expanded="false" aria-controls="id-of-content">Open</span>
   <div aria-hidden="true" id="id-of-content"></div>
</div>



*/

var app = app || {};
(function ($) {
   app.expander = new function () {
      var _self = this;
      var _settings = [];

      this.init = function () {
         var $expander = $('.js-expander');
         if (!$expander.length) {
            return;
         }
         $expander.each(function (index) {
            var $expander = $(this);

            //give the expander an ID so that we can store settings for it in an array
            $expander.attr('data-expander-id', index);



         });

         $(document).on('click', '.js-expander-toggle', function () {
            var $expander = $(this).parents('.js-expander');
            var id = $(this).attr('aria-controls');
            _self.toggle($expander, id);
         });

         $(document).on('click', '.js-expander-close-all', function () {
            _self.closeAll();
         });


      };

      this.toggle = function ($expander, id) {

         var expanded = $expander.find('.js-expander-toggle').attr('aria-expanded');

         if (expanded == "true") {
            $expander.find('.js-expander-toggle').attr('aria-expanded', 'false').attr('title', 'Expand');
            $('#' + id).attr('aria-hidden', 'true');
         }
         else {
            $expander.find('.js-expander-toggle').attr('aria-expanded', 'true').attr('title', 'Collapse');
            $('#' + id).attr('aria-hidden', 'false');
         }

         app.aria.tabIndex.enableVisible($('body'));
      };

      this.closeAll = function () {
         $('.js-expander-toggle').each(function () {
            var $expander = $(this).parents('.js-expander');
            var id = $(this).attr('aria-controls');
            $expander.find('.js-expander-toggle').attr('aria-expanded', 'false').attr('title', 'Expand');
            $('#' + id).attr('aria-hidden', 'true');
         });

      };



   };

   app.expander.init();

})(jQuery);




if (!customElements.get('icon-expander')) {
   customElements.define('icon-expander', class IconExpnader extends HTMLElement {
      constructor() {
         super();
         this.toggle = this.querySelector('[icon-expander-toggle]');
         this.panel = this.querySelector('[icon-expander-panel]');
         ['click', 'mouseover', 'focus'].forEach((event) => {
            this.toggle.addEventListener(event, (evt) => {
               this.toggle.setAttribute('aria-expanded', 'true');
               this.panel.setAttribute('aria-hidden', 'false');
            });
         });

         ['blur', 'mouseout'].forEach((event) => {
            this.toggle.addEventListener(event, (evt) => {
               this.toggle.setAttribute('aria-expanded', 'false');
               this.panel.setAttribute('aria-hidden', 'true');
            });
         });

      }

   });
}
